import type { AnyFSA } from '@makemydeal/dr-browser-utils';

import { ReduxMiddleware, ReduxNext, ReduxStore, bootstrapActionTypes } from '@makemydeal/dr-shared-store';
import { MiddlewareManager } from '@makemydeal/dr-activities-role-assumption';
import type { DashStoreMiddlewareApi } from '@makemydeal/dr-dash-store/types/appState';

import { configureRoleAssumption } from './config';

// keep a cached version of the middleware once we're able to build it.
// exported to support testing
export let cachedRoleAssumptionMiddlewareMgr: MiddlewareManager | undefined;

// needed for testing
export const roleAssumptionMiddlewareClearCache = () => (cachedRoleAssumptionMiddlewareMgr = undefined);

export const roleAssumptionMiddleware: ReduxMiddleware<any> = (store: ReduxStore<any>) => (next: ReduxNext) => (action: AnyFSA) => {
    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS: {
            cachedRoleAssumptionMiddlewareMgr = configureRoleAssumption();

            break;
        }
    }

    if (cachedRoleAssumptionMiddlewareMgr) {
        cachedRoleAssumptionMiddlewareMgr.middleware(store as DashStoreMiddlewareApi)(next)(action);
    } else {
        next(action);
    }
};
